const BuildMenu = (loadSkills, loadProjects, loadLicensePlates, loadPayslips, completed, loadOnBehalfOfManager, loadAdmin, loadStayBenefit, payrollAdmin, loadHouseholdItems) => {
    // NOTE: 'classes' property must exist, even if it is empty. otherwise active links in nav menu are broken
    // (see navItem.tsx in Clayco-Component-Library)
    let nav = [
        {
            url: "/Home",
            text: "Home",
            target: "_self",
            classes: "",
            scope: "internal",
        }        
    ];

    nav.push({
        url: "/ProfileLanding",
            text: "My Profile",
            target: "",
            classes: "",
            scope: "internal",
            children: buildProfileChildren(loadLicensePlates, loadAdmin)
        });

    if (loadPayslips) {
        // Casing normalized to match route path '/PayrollLanding'
        const payrollChildren = [
            {
                url: "/Payslips",
                text: "Payslips",
                target: "_self",
                classes: "",
                scope: "internal",
            },
            {
                url: "/TaxStatements",
                text: "Tax Statements",
                target: "_self",
                classes: "",
                scope: "internal",
            }
        ];

    if (loadStayBenefit || payrollAdmin) {
            payrollChildren.push({
                url: "/StayBenefit", // existing Stay Benefit
                text: "Stay Benefit Form",
                target: "_self",
                classes: "",
                scope: "internal",
            });
        }
        // Household Items has its own rule (same job families + its own PayrollAdmin access list)
        if (loadHouseholdItems || payrollAdmin) {
            payrollChildren.push({
                url: "/HouseholdItems",
                text: "Household Items Form",
                target: "_self",
                classes: "",
                scope: "internal",
            });
        }
        nav.push({
            url: "/PayrollLanding",
            text: "Payroll",
            target: "",
            classes: "",
            scope: "internal",
            children: payrollChildren
        });
    }

    if (loadSkills){
        if (!completed){
            if (loadOnBehalfOfManager){
                nav.push({
                    url: "/SkillsLanding",
                    text: "Skills & Experience",
                    target: "",
                    classes: "",
                    scope: "internal",
                    children: [{
                        url: "/Skillsmanagement",
                        text: "On-Behalf-Of-Management",
                        target: "_self",
                        classes: "",
                        scope: "internal",
                    }]
                });
            }
            else{
                nav.push({
                    url: "/SkillsLanding",
                    text: "Skills & Experience",
                    target: "",
                    classes: "",
                    scope: "internal",
                    children: []
                });
            }
        }
        else{
            nav.push({
                url: "/SkillsLanding",
                text: "Skills & Experience",
                target: "",
                classes: "",
                scope: "internal",
                children: buildSkillsMenu(loadProjects, loadOnBehalfOfManager)
            });
        }
    }

    return nav;
}

const buildProfileChildren = (loadLicensePlates, loadAdmin) => {
    let nav = [];

    nav.push({
        url: "/Profile/Info",
        text:"Personal Information",
        target: "_self",
        classes:"",
        scope:"internal"
    });
    nav.push({
        url: "/Profile/Contacts",
        text: "Emergency Contacts",
        target: "_self",
        classes:"",
        scope:"internal"
    });

    if (loadLicensePlates){
        nav.push({
            url: "/Profile/Plates",
            text: "License Plates",
            target: "_self",
            classes: "",
            scope: "internal"
        })
    }

    if (loadAdmin){
        nav.push({
            url: "/Profile/Admin",
            text: "Admin",
            target: "_self",
            classes:"",
            scope: "internal"
        });
    }

    return nav;
}

const buildSkillsMenu = (loadProjects, loadOnBehalfOfManager) => {
    let children = [
        {
            url: "/Skills/education",
            text: "Education & Training",
            target: "_self",
            classes: "",
            scope: "internal",
        },
        {
            url: "/Skills/certifications",
            text: "Certifications",
            target: "_self",
            classes: "",
            scope: "internal",
        },
        {
            url: "/Skills/employment",
            text: "Employment History",
            target: "_self",
            classes: "",
            scope: "internal",
        },
        {
            url: "/Skills/community",
            text: "Community Involvement",
            target: "_self",
            classes: "",
            scope: "internal",
        },
        {
            url: "/Skills/media",
            text: "Media Relations",
            target: "_self",
            classes: "",
            scope: "internal",
        },
        {
            url: "/Skills/awards",
            text: "Awards & Achievements",
            target: "_self",
            classes: "",
            scope: "internal",
        }
    ];

    if (loadProjects){
        children.push({
            url: "/Skills/previousProjects",
            text: "Previous Project Experience",
            target: "_self",
            classes: "",
            scope: "internal",
        });
    }

    if(loadOnBehalfOfManager){
        children.push({
            url: "/Skillsmanagement",
            text: "On-Behalf-Of-Management",
            target: "_self",
            classes: "",
            scope: "internal",
        });
    }

    return children;
}

export default BuildMenu;